(function ($) { $(function () {
    $('a:not(.btn)').each(function () {
        $(this).attr('data-title', $(this).text());
    })
}); })(jQuery); 